import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/formula1-b.jpg?w=2048&ch=width&auto=format,compress"
      title="Las Carreras del Grand Prix en vivo"
      subtitle="Accede desde cualquier dispositivo"
      tagline={`Más de ${laChannelCount} canales con deportes, noticias, novelas y entretenimiento en español.`}
      networkSet="entertainmentLatino"
      noteLink="/la/formula1/"
    />
  )
}
